const STARTER_TRACK_SPECS = [
  {
    id: "starter-seven",
    title: "Starter 7",
    copy:
      "Seven guest puzzles each day across the main motifs, before you decide to subscribe.",
    puzzleCount: 7,
    backendCategory:
      "backRankMate endgame mate mateIn1 oneMove queenMove basic queenBishopMate mateInOne anastasiaMate",
    hidden: true,
  },
  {
    id: "back-rank",
    title: "Back Rank Mate",
    copy:
      "Classic back-rank finishes picked to make your first session clear and recognisable.",
    puzzleCount: 3,
    backendCategory: "backRankMate endgame mate mateIn1 oneMove",
  },
  {
    id: "queen-bishop",
    title: "Queen + Bishop Battery",
    copy:
      "Short tactical finishes built around queen-and-bishop pressure and direct threats.",
    puzzleCount: 2,
    backendCategory: "queenMove basic queenBishopMate mateInOne",
  },
  {
    id: "anastasia",
    title: "Anastasia's Mate",
    copy:
      "Sharp mating nets built around trapped-king geometry and forcing checks.",
    puzzleCount: 2,
    backendCategory: "anastasiaMate endgame mate mateIn1 oneMove",
  },
];

export const GUEST_TRAINING_TRACKS = STARTER_TRACK_SPECS.map((track) => ({
  ...track,
}));

export const GUEST_TRAINING_TOTAL_PUZZLES = GUEST_TRAINING_TRACKS.reduce(
  (total, track) => total + track.puzzleCount,
  0
);

export const GUEST_TRAINING_TOTAL_CATEGORIES = GUEST_TRAINING_TRACKS.length;

export const DEFAULT_GUEST_TRAINING_TRACK_ID =
  GUEST_TRAINING_TRACKS[0]?.id || "";

export const GUEST_ENTRY_MAP_TRACK_ID = "starter-seven";

export function getGuestTrainingTrack(trackId) {
  return (
    GUEST_TRAINING_TRACKS.find((track) => track.id === trackId) ||
    GUEST_TRAINING_TRACKS[0] ||
    null
  );
}

export function hasGuestTrainingTrack(trackId) {
  return GUEST_TRAINING_TRACKS.some((track) => track.id === trackId);
}
